import { Button, Stack, Typography } from '@mui/material';
import { Image } from 'app/components';
import React from 'react';
import { useHistory } from 'react-router-dom';

const NotFound = () => {
  const history = useHistory();

  return (
    <Stack
      direction='column'
      alignItems='center'
      justifyContent='center'
      sx={{
        height: '100vh',
        position: 'relative',
      }}>
      <Stack
        direction='row'
        justifyContent='center'
        sx={(theme) => ({
          maxWidth: '560px',
          marginLeft: 'auto',
          marginRight: 'auto',
          textAlign: 'center',
          paddingLeft: theme.spacing(4),
          paddingRight: theme.spacing(4),
          img: {
            height: '360px',
            paddingBottom: theme.spacing(8),
          },
        })}>
        <Image name='error-404.svg' alt='error-404' />
      </Stack>
      <Stack
        direction='column'
        alignItems='center'
        spacing={2}
        sx={(theme) => ({
          maxWidth: '560px',
          marginLeft: 'auto',
          marginRight: 'auto',
          textAlign: 'center',
          paddingLeft: theme.spacing(3),
          paddingRight: theme.spacing(3),
          '.MuiButton-root': {
            padding: theme.spacing(2, 3),
          },
          '.MuiTypography-body2': {
            fontSize: '14px',
            color: theme.palette.text.secondary,
          },
        })}>
        <Typography variant='h4'>Ой, почему вы здесь?</Typography>
        <Typography variant='body2'>
          Приносим извинения за неудобства. Похоже, вы пытаетесь получить доступ к странице, которая была удалена или никогда не
          существовала.
        </Typography>
        <Button size='large' color='primary' variant='contained' onClick={history.goBack} disableElevation>
          Вернуться назад
        </Button>
      </Stack>
    </Stack>
  );
};

export default NotFound;
